document.addEventListener('DOMContentLoaded', function () {
  switchImage()
  watchDrawer()
  watchCartItems()
})

function switchImage() {
  // .cart-item for /cart
  // #cart-notification-product' for upper righr corner
  const rows = document.querySelectorAll('.cart-item, #cart-notification-product')
  console.log(rows)
  rows.forEach((row) => {
    const image = row.querySelector('img')
    if (!image) {
      return
    }

    const dtNodes = row.querySelectorAll('dt')
    console.log(dtNodes)
    dtNodes.forEach((node) => {
      const text = node.textContent
      console.log(text)
      if (text === 'pacdora-image3D:') {
        const parentNode = node.parentNode
        const ddNode = parentNode.querySelector('dd')
        if (ddNode) {
          image.src = ddNode.textContent
        }

        parentNode.hidden = true
      }
    })
  })
}

/**
dynamic watch drawer, if drawer is visible, do switchimage
**/
// 使用MutationObserver监听drawer的可见性变化

function watchDrawer() {
  // .cart-notification for cart drawer
  // .cart-items for cart item in cart page
  const cartNotification = document.querySelector('.cart-notification')
  if (!cartNotification) {
    return
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'style' || mutation.attributeName === 'class') {
        // 获取当前的可见性状态
        const isVisible = window.getComputedStyle(cartNotification).visibility === 'visible'

        if (isVisible) {
          switchImage()
        }
      }
    })
  })

  const config = { attributes: true, attributeFilter: ['style', 'class'] }
  observer.observe(cartNotification, config)
}

function watchCartItems() {
  // .cart-items for cart item in cart page
  const form = document.querySelector('form#cart')
  if (!form) {
    return
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      console.log(mutation.addedNodes)
      mutation.addedNodes.forEach((node) => {
        if (node.classList.contains('cart-items') && node.nodeName == 'TABLE') {
          switchImage()
          return
        }
      })
    })
  })

  const config = { childList: true, subtree: true }
  observer.observe(form, config)
}
